/** * * Asynchronously loads the component for
NetworkCoverage
* */ import { lazyLoad } from "utils/loadable";
export const NetworkCoverage = lazyLoad(
  () => import("./index"),
  (module) => module.NetworkCoverage
);
